export default "__VITE_ASSET__DgeiPzrF__"